// extracted by css-extract-rspack-plugin
export default {"wrapper":"MultiActions-module__wrapper--pkLhQ","controls":"MultiActions-module__controls--OWf8U","checkbox":"MultiActions-module__checkbox--WrivB"};